import { config } from "../env";
import {
  Delete,
  get,
  patch,
  post,
  postFileUpload,
  postFileUploadOnlyToken,
} from "./helpers/http-handler";

export const clientFileUpload = (payload: object) =>
  postFileUpload(`${config.ADMIN_URL}/media-uploads/file/upload`, payload);

export const clientFileUploads = (payload: object) =>
  postFileUpload(`${config.API_URL}/media-uploads/file/upload`, payload);

export const clientAdminFileUpload = (payload: object) =>
  postFileUploadOnlyToken(
    `${config.API_URL}/media-uploads/file/upload`,
    payload
  );

export const clientAdminPublicFileUpload = (payload: object) =>
  postFileUploadOnlyToken(
    `${config.API_URL}/media-uploads/file/upload/public`,
    payload
  );

export const adminCreateOrganization = (payload: object) =>
  post(`${config.API_URL}/organisation`, payload);

export const adminGetOrganization = (queryRequest: string) =>
  get(`${config.API_URL}/organisation?${queryRequest}`);

export const adminGetSpecificOrganization = (id: string) =>
  get(`${config.API_URL}/organisation/${id}`);

export const adminUpdateSpecificOrganization = (id: string, payload: object) =>
  patch(`${config.API_URL}/organisation/${id}`, payload);

export const adminDeleteSpecificOrganization = (id: string) =>
  Delete(`${config.API_URL}/organisation/${id}`);

export const adminUpdateBulkStatusOrganization = (payload: object) =>
  patch(`${config.API_URL}/organisation/bulk/active-inactive`, payload);

// admin

export const CreateOrganization = (payload: object) =>
  post(`${config.API_URL}/organisation`, payload);

export const GetOrganization = (queryRequest: string) =>
  get(`${config.API_URL}/organisation?${queryRequest}`);

export const GetSpecificOrganization = (id: string) =>
  get(`${config.API_URL}/organisation/${id}`);

export const UpdateSpecificOrganization = (id: string, payload: object) =>
  patch(`${config.API_URL}/organisation/${id}`, payload);

export const DeleteSpecificOrganization = (id: string) =>
  Delete(`${config.API_URL}/organisation/${id}`);

export const UpdateBulkStatusOrganization = (payload: object) =>
  patch(`${config.API_URL}/organisation/bulk/active-inactive`, payload);

export const LegacyTaskFileUpload = (payload: object) =>
  postFileUpload(`${config.API_URL}/legacy-tasks/document`,payload);

export const LegacyTaskFileDelete = (id: string) =>
  Delete(`${config.API_URL}/legacy-tasks/document/${id}`);
